<template>
    <div class="">

        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>

        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>GF Payment</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block">
                        <template >
                            <div class="report-button-contents d-flex align-items-center">
                                <div class="title mr-2">From Month</div>
                                <div class="value mr-2">
                                    <b-form-select v-model="start_month">
                                        <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                    </b-form-select>
                                </div>

                                <div class="title mr-2">From Year</div>
                                <div class="value mr-2">
                                    <b-form-select v-model="start_year">
                                        <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                    </b-form-select>
                                </div>

                                <div class="title mr-2">To Month</div>
                                <div class="value mr-2">
                                    <b-form-select v-model="end_month">
                                        <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                    </b-form-select>
                                </div>

                                <div class="title mr-2">To Year</div>
                                <div class="value mr-2">
                                    <b-form-select v-model="end_year">
                                        <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                            
                        </template>
                    </div>
                    <div class="d-inline-block float-right ml-2">
                        <!-- <button v-on:click="viewDetails()" class="btn btn-primary position-static mr-3">Preview Report</button> -->
                        <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                    </div>
                </div>

                <div class="ibox-content px-0 trz_ppl_wrapper_2">
                    <div class="d-inline-block trz_fields trz-custom-dropdown" >
                        <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group
                                            v-model="column_selected"
                                            :options="column_options"
                                            switches

                                        />
                                    </div>
                                    <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                    {{clickSelect}}
                    <div class="d-inline-block ml-2 report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                </div>

            </div>


        </div>
        <b-modal id="bv-modal-PYR" size="sm" hide-footer title="Yearly Payroll Report">
            <div>No data available for that date range!</div>
        </b-modal>

        <b-modal id="pf-yearly-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="PF Fiscal Year Report">
            <b-overlay  rounded="sm">
                <div class="clearfix row py-2 mb-2 border-bottom">

                    <div class="col-md-6">
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_id">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_id">
                            <!--aboni 10-11-21-->
                            <template v-for="(v,i,count) in detail">
                                <td class="2" v-if="i == 'Employee Name' || i== 'Employee Code' || i== 'designation' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) ">{{v}} </td>
                                <td v-else   class="2 text-right" ><div v-if="v==0">--</div><div v-else>{{formatMoney(v)}}</div></td>

                            </template>
                            <!--aboni 10-11-21-->


                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl','pf_settings', 'flag','leaver'],
        components: {

        },
        data(){

            return {

                pageUrl:this.$api_url,

                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                end_month: '',
                end_year: '',
                loader: false,
                showoverlay : true,
                report_data:[],

                payroll_reporting_data : [],
                details : [],

                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',


            }
        },
        methods:{
            validateDateRange() {
                const start = new Date(this.start_year, this.start_month - 1);
                const end = new Date(this.end_year, this.end_month - 1);

                if (start > end) {
                this.$bvToast.toast('Invalid range: Start month is after end month.', {
                            title: "Error",
                            variant: "danger",
                            solid: true,
                            });
                return false;
                }

                this.errorMessage = '';
                return true;
            },

            getReportWithValidation() {
                if (this.validateDateRange()) {
                this.getReport();  // Your actual report generation function
                }
            },
            plusOne(value)
            {
                value = Number(value) + 1;

                return value;
            },
            minusOne(value)
            {
                return Number(value) - 1;
            },
            updateSelected(data)
            {
                const filteredArray = this.column_selected.filter(item => item !== data);

                this.column_selected = filteredArray;
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);

                }.bind(this));
            },
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''

                url = this.$api_url + '/gf/report/payment';



                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }

                // Start: Rejwan: 23-06-2026
                // if (this.pf_settings && this.pf_settings.pf_year_end.opt_value == 12) {
                //     this.end_year = this.start_year;            // calendar-year fiscal
                // } else {
                //     this.end_year = parseInt(this.start_year) + 1;   // spanning fiscal
                //     this.start_month += 1;
                // }
                // // End: Rejwan: 23-06-2026

                let formData = new FormData();
                formData.append('start_year', this.start_year);
                formData.append('start_month', this.start_month);
                formData.append('end_year', this.end_year);
                formData.append('end_month', this.end_month);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                formData.append('column_selected', this.column_selected);

                let currentObj = this;
                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader', // your loader key in this component
                    (data) => {
                        if (data.errors) {
                            this.$bvToast.toast(data.errors, {
                                title: 'Warning',
                                variant: 'danger',
                                solid: true,
                            });
                        }
                    }
                );
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },
            // viewDetails: function()
            // {
            //     if(!this.checkNet()) return false;

            //     var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

            //     this.start_month_name = months[this.start_month];
            //     if(this.column_selected.indexOf('name') === -1){
            //         this.column_selected.unshift('name');
            //     }

            //     this.report_data = [];
            //     this.details = [];
            //     let formData = new FormData();
            //     formData.append('year', this.start_year);
            //     formData.append('viewmode', 1);
            //     formData.append('grid_report', 'Excel');
            //     formData.append('report', 1);
            //     formData.append('column_selected', this.column_selected);
            //     let url = this.$api_url + '/pf/report/fiscal';


            //     let currentObj = this;
            //     axios.post(url, formData).then(function (response)
            //     {
            //         var list_data = response.data;
            //         this.report_data = list_data;
            //         this.details = this.report_data.data;
            //         this.loader = false;
            //         this.download_file(response.data); // Rejwan: 03-07-2025 Reporting
            //     }.bind(this))
            //     .catch(error => {
            //         if(error.response){
            //             this.$bvModal.show('bv-modal-PYR');
            //             this.loader = false;
            //         }
            //     });



            //     this.$bvModal.show('pf-yearly-report');


            // },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                    params: {
                        flag:'pf_report',
                    }

                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {


                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);



                        available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);


                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    });


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);

                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str) {
                if(str == 'etin')
                {
                    return 'e-TIN';
                }
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            // this.start_year = new Date().getFullYear(); // Rejwan: 23-06-2026
            this.start_year = new Date().getFullYear() - 1; // Rejwan: 23-06-2026
            // this.start_month = this.currentMonth + 1;
            this.start_month = 7;
            this.end_year = new Date().getFullYear();
            this.end_month = 6;
            if (this.$cookies.isKey("report_column_selected")) {
                const columnCookie = this.$cookies.get("report_column_selected");

                if (columnCookie != null) {
                    if (typeof columnCookie === 'string') {
                        this.column_selected = columnCookie.split(',');
                    } else if (Array.isArray(columnCookie)) {
                        this.column_selected = columnCookie;
                    } else {
                        console.warn("Unexpected cookie value:", columnCookie);
                    }
                }
            }

            this.getPayrollDefaultField();
            this.getPayrollReporting();
        },
        computed:
        {
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            clickSelect()
            {
                var lt = this.column_selected_view.length;

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }

                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected,'24h');

            },
        }
    }
</script>
